import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import App from '@/components/App'
import ChatbotScreen from '@/components/ChatbotScreen'
import Login from '@/components/Login'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/:appId',
      name: 'App',
      component: App,
      redirect: '/:appId/chat',
      children: [
        {
          path: '/:appId/chat',
          name: 'ChatbotScreen',
          component: ChatbotScreen
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js